export const IncomingCallActionsTestIds = {
  DECLINE: 'mobile-call.decline-button',
  ANSWER: 'mobile-call.answer-button',
};
